/**
 * Ativos de marca servidos em `public/` (referência por URL absoluta na raiz do app).
 */

export const BRAND_LOGO_SRC = '/assets/images/retornaArLogo.png';
